import { useCallback } from 'react'
import readXlsxFile from 'read-excel-file';
import { LANGS_WITHOUT_TW } from '../../../Constants/lang';

const LANGS = LANGS_WITHOUT_TW

const schema = {
    'title.EN': {
        prop: 'title.EN',
        type: String,
        required: false
    },
    'title.ZH_CN': {
        prop: 'title.ZH_CN',
        type: String,
        required: false
    },
    'title.ZH_HK': {
        prop: 'title.ZH_HK',
        type: String,
        required: false
    },
    'description.EN': {
        prop: 'description.EN',
        type: String,
        required: false
    },
    'description.ZH_CN': {
        prop: 'description.ZH_CN',
        type: String,
        required: false
    },
    'description.ZH_HK': {
        prop: 'description.ZH_HK',
        type: String,
        required: false
    },
    'remarks': {
        prop: 'remarks',
        type: String,
        required: false
    },
    'type': {
        prop: 'type',
        type: String,
        required: false
    },
    'sectionId': {
        prop: 'sectionId',
        type: String,
        required: false
    },
    'question.EN': {
        prop: 'question.EN',
        type: String,
        required: false
    },
    'question.ZH_CN': {
        prop: 'question.ZH_CN',
        type: String,
        required: false
    },
    'question.ZH_HK': {
        prop: 'question.ZH_HK',
        type: String,
        required: false
    },
    'answerLabel.EN': {
        prop: 'answerLabel.EN',
        type: String,
        required: false
    },
    'answerLabel.ZH_CN': {
        prop: 'answerLabel.ZH_CN',
        type: String,
        required: false
    },
    'answerLabel.ZH_HK': {
        prop: 'answerLabel.ZH_HK',
        type: String,
        required: false
    },
    'inputMode': {
        prop: 'inputMode',
        type: String,
        required: false
    },
    'inputRegex': {
        prop: 'inputRegex',
        type: String,
        required: false
    },
    'minSize': {
        prop: 'minSize',
        type: Number,
        required: false
    },
    'maxSize': {
        prop: 'maxSize',
        type: Number,
        required: false
    },
    'mandatory': {
        prop: 'mandatory',
        type: Boolean,
        required: false
    },
    'filterKey': {
        prop: 'filterKey',
        type: String,
        required: false
    }
};

export default function useUpload() {

    const convertExcelToJson = useCallback(async (file) => {
        // 1. read excel file with schema
        const { rows, errors } = await readXlsxFile(file, { schema });

        if (errors.length > 0) {
            console.error('Excel resolve failed:', errors);
            throw new Error('Wrong Excel Data Format');
        }

        // 2. parse data to the expected data format
        const NODE_TYPES = { RADIO: 'RADIO' };

        let title = {}
        let description = {}

        const result = rows.map(row => {

            const uid = `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
            const type = row.type;
            const isRadio = type === NODE_TYPES.RADIO;

            let question = {}
            let answerLabel = {}

            for (let i = 0; i < LANGS.length; i++) {
                if(row?.[`title.${LANGS[i]}`]) Object.assign(title, { [LANGS[i]]: row?.[`title.${LANGS[i]}`] })
                if(row?.[`description.${LANGS[i]}`]) Object.assign(description, { [LANGS[i]]: row?.[`description.${LANGS[i]}`] })
                if(row?.[`question.${LANGS[i]}`]) Object.assign(question, { [LANGS[i]]: row?.[`question.${LANGS[i]}`] })
                if(row?.[`answerLabel.${LANGS[i]}`]) Object.assign(answerLabel, { [LANGS[i]]: row?.[`answerLabel.${LANGS[i]}`] })
            }

            if(!type) return null

            return {
                // id: uid,
                // type,
                // position: { x: 0, y: 0 },
                // data: {
                    id: uid,
                    sectionId: row?.sectionId ?? null,
                    question,
                    answerLabel,
                    type,
                    inputMode: row?.inputMode ?? null,
                    inputRegex: row?.inputRegex ?? null,
                    minSize: isRadio ? 1 : row?.minSize,
                    maxSize: isRadio ? 1 : row?.maxSize,
                    mandatory: row?.mandatory ?? false,
                    answerOptionList: null,
                    sequence: row?.sequence ?? 10,
                    status: "A",
                    parentQuestionId: null,
                    nextQuestionMap: null,
                    filterKey: row?.filterKey ?? null
                // }
            }
        });

        return {
            common: {
                title,
                description,
                remarks: rows[0]?.remarks ?? null,
            },
            detail: result.filter(i => i)
        };
    }, [])


    return {
        convertExcelToJson
    }
}
